import { StoreState } from 'app/state/types'
import { Messages } from 'app/types/common-types'

interface State extends StoreState {
    messages?: {
        [key: string]: MessageObject
    }
}

interface MessageObject {
    [key: string]: Messages | MessageObject
}

export default function getMessages(state: State) {
    return state.messages
}
